
  
  import { Component, Prop, Vue }                   from 'vue-property-decorator';
  import { Action, Getter }                         from 'vuex-class';
  import { NotificationEntity, 
          SessionEntity, 
          ConfigThemeService, 
          ConfigService } from '../..';


  @Component({
    name: 'NotificationBoxComponent',
  })
  export default class NotificationBoxComponent extends Vue {
      @Getter('isPresentationAvatarAllowed', { namespace: 'conversationSession' }) isPresentationAvatarAllowed!: boolean;
      @Getter('conversationSessionInfo', { namespace: 'conversationSession' }) conversationSessionInfo!: SessionEntity | undefined;
      @Action('markNotificationAsSeen', { namespace: 'messages' }) markNotificationAsSeen: any;


      @Prop() notifications!: NotificationEntity[]
      @Prop() close!: any

      middleClickClose(e : MouseEvent) {
        if (e.button === 1) { // middle click
          e.preventDefault()
          this.close()
        }
      }

      carouselChange(index : number) {
        // FIX THIS => have a proper getter to see if the chatbot is opened or not
        if (!this.isPresentationAvatarAllowed &&  !this.notifications[index].seen) {
          this.markNotificationAsSeen({notif: this.notifications[index], sessionInfo: this.conversationSessionInfo})
        }
      }

      get carrouselCycleTime() {
        return ConfigThemeService.getNotificationBoxStyle(this.$vuetify).carrouselCycleTimeMs;
      }

    /** ******************************************************************************************* */
    /**                                   TITTLE FOR BUTTONS                                        */
    /** ******************************************************************************************* */

    get closeNotificationButtonTitle() {
      return ConfigService.getCloseNotificationButtonTitle();
    }

  }
